module.exports = __webpack_public_path__ + "static/media/bed.bcdd6e5f.svg";